import { TimePicker as AntDTimePicker } from 'antd';
import dayjs from 'dayjs';
import './CustomTime.css';

const format = 'hh:mm A';

const TimePicker = ({ handleTimeChange, name, width = undefined, disabled = false, errTxts, value, setValue }) => {
	return (
		<div className="mt-12">
			<div className="flex flex-col justify-end placeholder_css_only">
				<AntDTimePicker
					allowClear={false}
					className="placeholder_field_custom_time"
					defaultValue={value ? dayjs(value) : undefined}
					disabled={disabled}
					format={format}
					onChange={(e) => {
						handleTimeChange(e.format('HH:mm'), name);
						setValue(e);
					}}
					placeholder="--:-- --"
					showNow={false}
					status={errTxts[name] ? 'error' : ''}
					style={{
						border: 0,
						borderBottom: `1px solid ${errTxts[name] ? 'red' : '#121212'}`,
						borderRadius: 0,
						width,
						boxShadow: 'none',
					}}
					use12Hours
				/>
			</div>
			<div className="text-pd-xs text-red mt-2">{errTxts[name]}</div>
		</div>
	);
};

export default TimePicker;
